import Layout from '../../internal/Layout.vue'
import DashboardPage from './Dashboard.vue'

const DashboardRoutes = {
  component: Layout,
  children: [
    {
      name: 'dash',
      path: '/',
      component: DashboardPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
      },
    },
  ],
}

export default DashboardRoutes
